var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResumeForm',{ref:"form",attrs:{"formLine":_vm.formLine,"data":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }